import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { POI, POICategory } from '../../types';
import { pois } from '../../data/mockData';
import { POIMarker } from '../Overlays/POIMarker';
import { POIFilters } from '../Filters/POIFilters';
import { POIPopupCard } from '../Panels/POIPopupCard';
import { TopNav } from '../shared/TopNav';
import { MainMenuPanel } from '../Panels/MainMenuPanel';
export function SurroundingsMode() {
  const [selectedPOI, setSelectedPOI] = useState<POI | null>(null);
  const [activeCategories, setActiveCategories] = useState<Set<POICategory>>(new Set(['Nature', 'Dining', 'Fitness']));
  const [focusedPosition, setFocusedPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [showMenu, setShowMenu] = useState(false);
  const [cameraDirection] = useState<'N' | 'S' | 'E' | 'W' | 'NE' | 'NW' | 'SE' | 'SW'>('N');
  const toggleCategory = (category: POICategory) => {
    const newCategories = new Set(activeCategories);
    if (newCategories.has(category)) {
      newCategories.delete(category);
    } else {
      newCategories.add(category);
    }
    setActiveCategories(newCategories);
  };
  const handlePOISelect = (poi: POI) => {
    setSelectedPOI(poi);
    // Center/focus on the POI with animation
    setFocusedPosition(poi.coordinates);
  };
  const handleClosePopup = () => {
    setSelectedPOI(null);
    setFocusedPosition(null);
  };
  const filteredPOIs = pois.filter(poi => activeCategories.has(poi.category));
  return <>
      <TopNav onMenuClick={() => setShowMenu(true)} cameraDirection={cameraDirection} data-id="element-791" />

      {/* Main Menu Panel */}
      <MainMenuPanel isOpen={showMenu} onClose={() => setShowMenu(false)} onOpenControls={() => console.log('Open Controls')} onOpenMediaGallery={() => console.log('Open Media Gallery')} onOpenSettings={() => console.log('Open Settings')} data-id="element-792" />

      {/* Left Filters Panel */}
      <POIFilters pois={pois} selectedCategories={activeCategories} onCategoryToggle={toggleCategory} onPOISelect={handlePOISelect} data-id="element-793" />

      {/* Animated Background Overlay for Focus Effect */}
      <AnimatePresence data-id="element-794">
        {focusedPosition && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 pointer-events-none z-10" style={{
        background: `radial-gradient(circle at ${focusedPosition.x}% ${focusedPosition.y}%, transparent 15%, rgba(0,0,0,0.4) 40%)`
      }} data-id="element-795" />}
      </AnimatePresence>

      {/* Markers - Positioned to the right of filter menu */}
      <div className="absolute inset-0 pointer-events-none" style={{
      left: '320px'
    }} data-id="element-796">
        <div className="relative w-full h-full pointer-events-auto" data-id="element-797">
          {filteredPOIs.map((poi, index) => <POIMarker key={poi.id} poi={poi} isSelected={selectedPOI?.id === poi.id} onSelect={() => handlePOISelect(poi)} delay={index * 0.05} data-id="element-798" />)}
        </div>
      </div>

      {/* Popup Card */}
      <AnimatePresence data-id="element-799">
        {selectedPOI && <POIPopupCard poi={selectedPOI} onClose={handleClosePopup} position={selectedPOI.coordinates} data-id="element-800" />}
      </AnimatePresence>
    </>;
}